import { Link } from "react-router-dom";
import { LandingHeader } from "../components/landing-chrome";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-ink-50">
      <LandingHeader />
      <main className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
        <article className="prose prose-ink max-w-none">
          <h1 className="text-3xl font-bold tracking-tight text-ink-900">
            Terms of Service
          </h1>
          <p className="mt-2 text-sm text-ink-500">
            Last updated: June 9, 2026
          </p>

          <Section title="1. Acceptance of Terms">
            By creating an account or using BrandEcho ("Service"), you agree to
            these Terms of Service. If you do not agree, do not use the Service.
          </Section>

          <Section title="2. The Service">
            BrandEcho turns long-form text into native variants for X, Bluesky,
            LinkedIn, Threads, and Instagram, and helps you schedule and publish
            them. The Service may add or remove features at any time.
          </Section>

          <Section title="3. Your account">
            You are responsible for keeping your credentials safe and for all
            activity under your account. You must be at least 13 years old. We
            may suspend accounts that violate these Terms or applicable law.
          </Section>

          <Section title="4. Plans, billing, free trial">
            Paid plans renew automatically each month at the rate shown at
            signup. Your 7-day free trial converts to a paid subscription at
            the end of day 7 unless you cancel in Settings → Billing during
            the trial. Cancellations take effect at the end of the current
            billing period; we do not refund partial months.
          </Section>

          <Section title="5. Connected social accounts">
            You authorize BrandEcho to publish posts to social accounts you
            connect (X, Bluesky, LinkedIn, Threads, Instagram). You are
            responsible for the content you publish, and you must comply with
            each platform's rules. We do not pre-moderate your content.
          </Section>

          <Section title="6. Acceptable use">
            You may not use the Service to publish illegal content, infringe
            on others' rights, run spam, harass other users, or attempt to
            reverse-engineer or overload the platform. We may remove content
            and terminate accounts that violate this section.
          </Section>

          <Section title="7. AI-generated output">
            Variants generated by BrandEcho are provided "as is". You are
            responsible for reviewing every post before publishing. We do not
            train external models on your private content.
          </Section>

          <Section title="8. Intellectual property">
            You retain ownership of your inputs and outputs. By using the
            Service you grant us a limited license to process your content for
            the purpose of providing the Service.
          </Section>

          <Section title="9. Termination">
            You can delete your account at any time in Settings → Danger zone.
            We can suspend or terminate accounts for violations of these
            Terms. On termination your data is deleted within 30 days.
          </Section>

          <Section title="10. Disclaimers">
            The Service is provided "as is" without warranties of any kind. We
            don't guarantee uptime, deliverability, or that scheduled posts
            will publish — third-party platforms can change APIs at any time.
          </Section>

          <Section title="11. Limitation of liability">
            To the fullest extent allowed by law, BrandEcho's total liability
            for any claim is limited to the amount you paid us in the 12
            months preceding the claim.
          </Section>

          <Section title="12. Changes to these Terms">
            We may update these Terms; we'll post the new version here with a
            new "Last updated" date and email account holders for material
            changes.
          </Section>

          <Section title="13. Contact">
            Questions: <a href="mailto:hello@brandecho.com">hello@brandecho.com</a>
          </Section>

          <p className="mt-10 text-sm">
            <Link to="/" className="text-brand-600 hover:underline">
              ← Back to BrandEcho
            </Link>
          </p>
        </article>
      </main>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <>
      <h2 className="mt-8 text-xl font-semibold text-ink-900">{title}</h2>
      <p className="mt-2 text-ink-700">{children}</p>
    </>
  );
}
